import orders from "./orders";
import statistics from "./statistics";
import vaccountPayments from "./vaccount-payments";

export const nshop = {
    orders,
    statistics,
    vaccountPayments,
};

export default nshop;
